import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import LotStatusText from '~/components/lotStatusText/lotStatusText';
import { Card } from 'reactstrap';
import styles from './styles.css';

const LotDetailCard = ({ className, product, currentVolume, currentTank, status }) => {
  return (
    <Card className={cn(className, 'pv3')}>
      <div>
        <h3 className=" ph3 f4 mt0">{product.name}</h3>
        <div className={`flex ${styles.detail} ph3 pt3`}>
          <div className="tc flex-grow-1">
            <h5 className="f5 lt">Volume</h5>
            <h6 className="b f4">{currentVolume}L</h6>
          </div>
          <div className="tc flex-grow-1">
            <h5 className="f5 lt">Tank</h5>
            {currentTank ? (
              <Link to={`/tanks/${currentTank.id}`}>
                <h6 className="b link">{currentTank.name}</h6>
              </Link>
            ) : (
              '--'
            )}
          </div>
          <div className="tc flex-grow-1">
            <h5 className="f5 lt">Status</h5>
            <h6 className="b">
              <LotStatusText capitalise status={status} />
            </h6>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default LotDetailCard;



// WEBPACK FOOTER //
// ./src/components/lotDetailCard/lotDetailCard.jsx